import axios from 'axios';
// import store from '../store';
import moment from 'moment';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'pinjamankredit';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(baseurl, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer','nasabahkey', 
                'collectability','nomor', 'agreement', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2','dod1', 
                'dod2','wo_status','contract_status','pjxkey','isICP'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    listrrd(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer','nasabahkey', 'collectability',
                'no_kontrak', 'no_agreement', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2','dod1', 'dod2',
                 'status', 'status_approval', 'wo_status','contract_status','pjxkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/rrd${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    pinjamanoutstanding(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('obj',obj);
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer',
                'pinjamankey','customer_id','wo_status', 'uraian','nomor', 'collector_id', 
                'model_pinjaman', 'outstand','typeoutstand','tglsettl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/outstanding${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `daftar-pinjaman-${moment().format('YYYY-MM')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportxlsRRD(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsRRD/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `daftar-pinjaman-rrd-${moment().format('YYYY-MM')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportxlsPrepaidAlloc(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer','nasabahkey', 'collectability','nomor', 'agreement', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2','dod1', 'dod2','wo_status','contract_status','pjxkey', 'CustCode', 'pjxname', 'next_installment_date_1' , 'next_installment_date_2','next_installment_due_date_1','next_installment_due_date_2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsPrepaidAlloc/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `prepaid-alloc-${moment().format('YYYY-MM')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    colectabilityreport(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl','admin','pjxkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/colectability-report${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    DAreport(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'periode', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/DA-report${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    DAreport_wo30sep19(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'periode', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/DA-report-wo30sep19${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    APreport(obj) {
        //console.log("#obj: ", obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'date'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/AP-report${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    APreport_wo30sep19(obj) {
        //console.log("#obj: ", obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'date'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/AP-report-wo30sep19${str}`;
                const { data } = await axios.get(url);
                // const { meta, list } = data;
                // obj.total = meta.total;
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxlsCR(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['tgl',"admin","pjxkey"];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsCR/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ColllectionReport_${moment(obj.tgl).format('YYYY-MM-DD')}_${obj.pjxname}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportxlsDA(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsDA/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `DA_${moment(obj.tgl2).format('YYYY-MM')}_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxlsDA_wo30sep19(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsDA-wo30sep19/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `DailyAgingReport__${moment(obj.tgl2).format('YYYY-MM')}_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportxlsAP(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'date'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsAP/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `AgingPinjaman_${moment(obj.date).format('YYYY-MM')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxlsAP_wo30sep19(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'date'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsAP-wo30sep19/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `AgingPinjamanReport_${moment(obj.date).format('YYYY-MM')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportDtlxls(pinjamankey) {
        return new Promise((resolve, reject) => {
            try {
                const url = `/${baseurl}/exportDtlxls/${pinjamankey}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'detailpinjaman.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    detail(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detailrequest(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detailrequest/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detailrequestedit(requestkey) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log("#requestkey api: ", requestkey);
                const { data } = await axios.get(`${baseurl}/detailrequestedit/${requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    requestCurr() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/requestCurr`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    
    getRequestHeader(requestkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/request-header/${requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getRequestLine(requestkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/request-line/${requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    isLunas(jaminankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/isLunas/${jaminankey}`);
                //console.log("#data: ", data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    
    saveRequest(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/saveRequest`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    calcpelunasan(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                try {
                    const keys = ['pinjamankey', 'tglpelunasan'];
                    let str = '';
                    for (const key in obj) {
                        if (keys.indexOf(key) >= 0 && obj[key]) {
                            str += str ? '&' : '?';
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                    const url = `/${baseurl}/calc-pelunasan${str}`;
                    const { data } = await axios.get(url);
                    resolve(data);
                } catch (error) {
                    errorHandler(error, reject)
                }
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    calcpelunasanv2(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                try {
                    const keys = ['pinjamankey', 'tglpelunasan'];
                    let str = '';
                    for (const key in obj) {
                        if (keys.indexOf(key) >= 0 && obj[key]) {
                            str += str ? '&' : '?';
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                    const url = `/${baseurl}/calc-pelunasan-v2${str}`;
                    const { data } = await axios.get(url);
                    resolve(data);
                } catch (error) {
                    errorHandler(error, reject)
                }
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    importdtPABxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/importdtPABxls`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    importdtPRKxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/importdtPRKxls`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savebulkdtPinjaman(arr) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savebulkdtPinjaman`, arr);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printjdwlangsuran(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey','printall'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/printjdwlangsuran${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportJdwlAngsuran(pinjamankey) {
        return new Promise((resolve, reject) => {
            try {
                const url = `/${baseurl}/exportJdwlAngsuran/${pinjamankey}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'jdwlangsuran.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    stopaccrue(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/stopaccrue`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    startaccrue(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/startaccrue`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    writeoff(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/writeoff`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    installmentduewithprepaid(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer','nasabahkey', 'collectability','nomor', 'agreement', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2','dod1', 'dod2','wo_status','contract_status','pjxkey', 'CustCode', 'pjxname', 'next_installment_date_1' , 'next_installment_date_2','next_installment_due_date_1','next_installment_due_date_2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/installment-due-with-prepaid${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    approvalpelepasandoc(formData) {
        return new Promise(async (resolve, reject) => {
            //console.log("#formData: ", formData);
            try {
                const { data } = await axios.post(`${baseurl}/send2wfpelepasandoc`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndoRRD(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`${baseurl}/send2wfCancelRRD/${obj.requestkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    LBPP(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'periode', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/LBPP${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    exportxlsLBPP(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsLBPP/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `LBPP_${moment(obj.tgl2).format('YYYY-MM-DD')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    closeeod(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/closing-end-of-day`, obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    printPDFDebiturInfo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/printPDFDebiturInfo`, obj);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

}